import { forwardRef, useCallback, useEffect, useMemo, useRef } from 'react'

import { useBooleanState } from 'hooks/useBooleanState'

import { SearchSelectContext } from './context'
import { SearchField } from './search_field'
import { Container } from './styles'

export const SearchSelect = forwardRef(({
  children,
  onFocus,
  onChange,
  onClose,
  ...params
}, ref) => {
  const [isOpen, openDropdown, closeDropdown] = useBooleanState(false)
  const containerRef = useRef()

  const handleFocus = useCallback((e) => {
    openDropdown()
    if (onFocus) {
      onFocus(e)
    }
  }, [openDropdown, onFocus])

  const handleChange = useCallback((e) => {
    openDropdown()
    if (onChange) {
      onChange(e)
    }
  }, [openDropdown, onChange])

  const captureListener = useCallback((event) => {
    if (containerRef.current.contains(event.target)) return
    if (onClose) onClose()
    closeDropdown()
  }, [closeDropdown, onClose])

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('click', captureListener, true)
    }

    return () => {
      document.removeEventListener('click', captureListener, true)
    }
  }, [captureListener, isOpen])

  const contextValue = useMemo(() => ({
    close: closeDropdown
  }), [closeDropdown])

  return (
    <SearchSelectContext.Provider value={contextValue}>
      <Container ref={containerRef}>
        <SearchField
          ref={ref}
          onFocus={handleFocus}
          onChange={handleChange}
          {...params}
        />
        {isOpen && children}
      </Container>
    </SearchSelectContext.Provider>
  )
})
